const dispatchMonetateQEvent = (eventName = '') => {
  if (eventName) {
    window.monetateQ = window.monetateQ || [];
    window.monetateQ.push(['trackEvent', [eventName]]);
  }
};

export default dispatchMonetateQEvent;
